<template>
  <v-stepper
    v-model="value"
    class="zoox-component zoox-stepper"
    :class="{'is-vertical': isVertical, altLabels}"
    :alt-labels="altLabels"
  >
    <v-stepper-header>
      <template v-for="(stepper, index) in steppers">
        <!--Evento emitido na mudança de valor do componente 
              @event change
              @property {Number} stepperId - Valor atual do componente
          -->
        <v-stepper-step
          :key="stepper.id"
          ref="stepper-item"
          :step="stepper.id"
          :complete-icon="stepper.icon"
          :complete="value > stepper.id"
          :color="stepper.color"
          @click="$emit('change', stepper.id)"
        >
          <span ref="stepper-label">
            {{ stepper.label }}
          </span>
        </v-stepper-step>
        <v-divider
          v-if="index < steppers.length - 1 && !isVertical && !altLabels"
          :key="index + 'a'"
          class="divider"
        >
        </v-divider>
        <div
          v-if="index < steppers.length - 1 && isVertical && !altLabels"
          :key="index + 'b'"
          :class="{'divider-column': isVertical}"
        ></div>
        <div
          v-if="index < steppers.length - 1 && altLabels && isVertical"
          :key="index + 'c'"
          :class="{'with-altlabels': altLabels}"
        ></div>
        <v-divider
          v-if="index < steppers.length - 1 && !isVertical && altLabels"
          :key="index + 'd'"
          :class="{'divider-horizontal': altLabels}"
        ></v-divider>
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
/**
 * O Stepper deve ser utilizado em formulários ou interações que são
 * grandes e precisam ser divididas em múltiplas etapas para melhor usabilidade.
 * @displayName Stepper
 */
export default {
  name: 'ZStepper',
  props: {
    /**
     * Posiciona a label abaixo do stepper
     */
    altLabels: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Steppers para serem criadas.
     *
     * @typedef Object {id:number,label:string,icon:string}
     */
    steppers: {
      type: Array,
      required: true,
    },
    /**
     * Define o valor atual do componente
     */
    value: {
      type: [Number, String],
      required: true,
    },
    /**
     * Aplica o estilo vertical ao componente
     */
    isVertical: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.zoox-stepper {
  --circle-size: 32px;
  box-shadow: none !important;
  background: transparent !important;
  font-weight: bold;
  font-size: 13px;
  display: flex;
  flex-direction: column;

  .v-stepper__header {
    flex-wrap: nowrap !important;
  }

  .v-stepper__step__step {
    cursor: pointer;
    height: var(--circle-size);
    width: var(--circle-size);
  }

  .v-stepper__step--inactive {
    .v-stepper__step__step {
      background-color: transparent !important;
      font-weight: bold;
      font-size: 13px;
      color: var(--black-300) !important;
      border: 2px solid var(--black-300);
    }
  }

  .v-stepper__label {
    font-weight: bold;
    font-size: clamp(0.8rem, 2vw, 13px);
    max-width: 15ch;
    overflow-wrap: break-word;
    text-align: center;
  }

  .v-stepper__step--active {
    .v-stepper__step__step {
      border: 2px solid var(--primary);
      background-color: transparent !important;
      color: var(--primary) !important;
    }
  }

  .v-stepper__step--active,
  .v-stepper__step--complete {
    color: var(--white);

    .v-stepper__label {
      color: var(--primary) !important;
    }

    .v-stepper__step__step {
      border: 2px solid var(--black-300);
    }
  }
}

.with-altlabels {
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  height: 24px;
  align-self: center;
  justify-self: center;
  margin: 5px 0px;
}

.divider-column {
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  height: 24px;
  margin: 5px 15px;
}

.divider-horizontal {
  .divider-column {
    border-left: 1px solid rgba(0, 0, 0, 0.2);
    height: 24px;
    margin: 5px 15px;
  }
}

.is-vertical {
  .v-stepper__header {
    display: flex;
    flex-direction: column;
    height: auto;

    .v-stepper__step {
      flex-basis: unset !important;
      padding: 0;
      margin: 0px !important;
    }
  }

  &:not(.altLabels) {
    .v-stepper__label {
      max-width: 100%;
      text-align: start;
    }
  }
}
</style>

<style lang="scss">
@media only screen and (max-width: 959px) {
  .zoox-stepper {
    .v-stepper__step {
      flex-basis: auto;
      gap: 5px;
    }
    .divider {
      max-width: 15%;
    }
    .v-stepper__step--active,
    .v-stepper__step--complete,
    .v-stepper__step--inactive {
      .v-stepper__label {
        display: unset !important;
      }
    }
  }
}
</style>
